<body>
    <section class="section_one" *ngIf="show">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="ibox">
                        <div class="ibox-title report_flexweb">
                            <div>
                                <h5 class="dashboard"> Dashboard</h5>
                            </div>
                            <div class="icon_flex">
                                <div>
                                    <button class="create" (click)="open()">Add New </button>
                                </div>
                            </div>
                        </div>
                        <div class="dashboardcard_grid">
                            <div class="card card-height" *ngFor="let emp of employes let i=index" (click)="page(emp)">
                                <div class="p">
                                    <figure>
                                        <!-- <img src="../../assets/image/photo12.svg" class="photo"> -->
                                        <img [src]="emp.imageUrl " class="photo" alt="Employee Photo">
                                    </figure>
                                </div>
                                <div class="text">
                                    <h1 class="text-name">{{emp.empName}}</h1>
                                    <h5 class="empname">{{emp.payRollId}}</h5>
                                    <h5 class="empname">{{emp.empId}}</h5>
                                    <h5 class="empname">{{emp.designation}}</h5>
                                    <h5 class="empname">{{emp.camerasAlloted}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- desktop table view close-->
                </div>
            </div>
        </div>
    </section>
    <section *ngIf="!show">
        <div class="container">
            <div class="row">
                <div class="col-md-9">
                    <div class="ibox">
                        <div>
                            <div class="searchemp_flex">
                                <div class="searchemp_left">
                                    <div *ngIf="search">
                                        <div>
                                            <div>
                                                <button class="backbutton" (click)="Dashboard()"><span><img
                                                            src="../../assets/image/outline-arrow-back.svg"></span>Back</button>
                                            </div>
                                            <!-- <h6 class="search-text">Search Employess</h6>   
                                             <input  name="search" class="form-control" type="text" /> 
                                            <div class="input-group">
                                                <input class="form-control py-2 border-right-0 border" type="search"
                                                    value="Search Employess" id="example-search-input"
                                                    [(ngModel)]="searchTerm">
                                                <span class="input-group-append">
                                                    <button class="btn btn-outline-secondary border-left-0 border"
                                                        type="button" (click)="employessearch()">
                                                        <i class="fa fa-search"></i>
                                                    </button>
                                                </span>
                                            </div>  -->
                                        </div>
                                        <div class="card" *ngFor="let emp of searchemployesslist">
                                            <div class="p">
                                                <figure>
                                                    <img [src]="emp.imageUrl" class="photo">
                                                </figure>
                                            </div>
                                            <div class="text">
                                                <h1 class="text-name">{{ emp.empName }}</h1>
                                                <hr>
                                                <p class="text-payroll">PAYROLL ID: {{ emp.payrollId }}
                                                </p>
                                                <hr>
                                                <p class="text-designation">DESIGNATION: {{
                                                    emp.designation }}</p>
                                                <hr>
                                                <p class="text-date">MOBILE NO: {{ emp.mobileNo }}</p>
                                            </div>
                                            <ng-template #noData>
                                                <p>No employees found.</p>
                                            </ng-template>
                                        </div>

                                        <div>
                                        </div>
                                    </div>
                                </div>
                                <div class="cameraContainer">
                                    
                                <div class="searchemp_right">
                                    <div class="ibox-title report_flexweb">
                                        <div>
                                          <h5 class="Existingcameras">
                                            {{ selectedImages.length > 0 ? 'Selected Cameras ' + selectedImages.length : 'Existing Cameras ' + existingcamera?.length }}
                                          </h5>
                                        </div>
                                        <div class="icon_flex">
                                          <div>
                                            <!-- Only show button when selectedImages has one or more items -->
                                            <button *ngIf="selectedImages.length > 0" class="create" (click)="deleteSelectedImages()">
                                              <i class="fas fa-trash"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    <div class="cameras1">
                                        <ng-container *ngFor="let image of existingcamera ">
                                            <figure (click)="openDialog($event,image)" class="cctv">
                                                <img src="{{image.cctvFrameS3Url}}" alt="cctvimg"
                                                    class="cameras cameras2" *ngIf="image.isSelected">
                                                <img src="{{image.cctvFrameS3Url}}" alt="cctvimg" class=" cameras "
                                                    *ngIf="!image.isSelected">
                                                <hr>
                                                <p class="buliding-name"> {{image.buildingName}}</p>

                                                <img src="../../assets/image/img-select (1).svg" class="arrow"
                                                    (click)="selectImage($event,image)" *ngIf="!image.isSelected" />
                                                <img src="../../assets/image/img-select.svg" class="arrow"
                                                    (click)="selectImage($event,image)" *ngIf="image.isSelected" />
                                            </figure>
                                        </ng-container>

                                    </div>
                                </div>
                                <div class="dis_col" *ngIf="cctvcameralist">
                                    <p>Draged Cameras </p>
                                    <!-- DROP TARGET LIST -->
                                    <div cdkDropList id="dropTarget" class="drop-target"
                                        [cdkDropListData]="droppedCameras" [cdkDropListConnectedTo]="['dragSource']"
                                        (cdkDropListDropped)="onDrop($event)">
                                        <ng-container *ngFor="let image of droppedCameras">
                                            <figure (click)="openDialog($event,image.item)" class="cctv">
                                                <img [src]="image.item.cctvFrameS3Url" alt="cctvimg" class="cameras" />
                                                <p class="buliding-name">{{ image.buildingName }}</p>
                                            </figure>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="buttonContainer" *ngIf="cctvcameralist">
                                    <button type="submit" class="submitButton" (click)="saveDraggedCameras()">Save
                                        All</button>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- desktop table view close-->
                </div>
            </div>
        </div>
        <aside *ngIf="!show" class="aside">
            <div class="container">
                <div class="heading">
                    <p class="addcamera font_size_20"> Add Camera</p>
                </div>
                <div>
                    <p class="campus-name">Campus Name</p>
                    <mat-select class="form_select">
                        <input type="text" class="matInput" matInput [formControl]="campusControl"
                            [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete"></mat-autocomplete>
                        <mat-option *ngFor="let item of filteredCampuses | async " [value]="item"
                            (click)="onCampusChange(item)">
                            {{ item.campusName }}
                        </mat-option>
                    </mat-select>
                </div>
                <div>
                    <p class="campus-name">Building Name</p>
                    <mat-select class="form_select">
                        <input type="text" class="matInput" matInput [formControl]="buildingControl"
                            [matAutocomplete]="auto2">
                        <mat-autocomplete #auto2="matAutocomplete"></mat-autocomplete>
                        <mat-option *ngFor="let building of filteredBuildings |async" [value]="building"
                            (click)="onbuilding(building)">
                            {{ building.buildingName }}
                        </mat-option>
                    </mat-select>
                </div>
                <!-- DRAGGABLE CAMERA LIST -->
                <!-- DRAG SOURCE LIST -->
                <div class="sidecameras" cdkDropList id="dragSource" [cdkDropListData]="cctvcameralist?.cameraDetails"
                    [cdkDropListConnectedTo]="['dropTarget']">
                    <ng-container *ngFor="let camera of cctvcameralist?.cameraDetails">
                        <figure cdkDrag [cdkDragData]="camera" class="cctv" (click)="openCameraDialog(camera)">
                            <img [src]="camera.cctvFrameS3Url" class="cameras" alt="Camera frame" />
                            <p class="buliding-name">{{ cctvcameralist.buildingName }}</p>
                        </figure>
                    </ng-container>
                </div>


            </div>
        </aside>

    </section>

</body>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>